import styled from 'styled-components';

export const Heading = styled.h1`
  margin: 0 0 0.5rem 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.25rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
`;

export const Paragraph = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const Greeting = styled.span`
  display: block;
`;

export const UserName = styled.span`
  font-weight: ${({ theme }) => theme.weights.bold};
`;
